import { render, staticRenderFns } from "./InfoMediaDeleted.vue?vue&type=template&id=50edbc10&scoped=true"
import script from "./InfoMediaDeleted.vue?vue&type=script&lang=js"
export * from "./InfoMediaDeleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50edbc10",
  null
  
)

export default component.exports